import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import { getPluralize } from '@r1-frontend/shared/helpers/pluralize';

import { data } from '~/src/features/reviews/components/GradesList/data';
import Review from '~/src/features/reviews/components/Review';
import { parseRusDate } from '~/src/helpers/date';
import { TState } from '~/src/store';

import * as ST from './styled';

export const SHOW_LINES_STEP = 7;
export const reviewText = getPluralize(['отзыв', 'отзыва', 'отзывов']);

const GradesList = () => {
    const [showLines, setShowLines] = useState(SHOW_LINES_STEP);
    const { cityIn } = useSelector((state: TState) => state.city.currentCity);
    const sortedData = useMemo(() => {
        return data.sort((a, b) => parseRusDate(b.date).getTime() - parseRusDate(a.date).getTime());
    }, []);

    return (
        <ST.ContentWrapper>
            <ST.Text data-test='grades-list-text'>{`${sortedData.length} ${reviewText(sortedData.length)} в ${cityIn}`}</ST.Text>
            <ST.Reviews data-test='grades-list-reviews'>
                {
                    sortedData.map((item, index) => {
                        if (index + 1 > showLines) {
                            return null;
                        }
                        return (<Review
                            key={item.date + index}
                            data={item}
                            order={index}
                        />);
                    })
                }
            </ST.Reviews>
            {sortedData.length > showLines &&
                <ST.ShowMoreBtn
                    data-test='grades-list-btn'
                    size={'medium'}
                    bType={'secondary'}
                    onClick={() => setShowLines(prev => prev + SHOW_LINES_STEP)}
                >
                    {'Показать больше отзывов'}
                </ST.ShowMoreBtn>
            }
        </ST.ContentWrapper>
    );
};

export default GradesList;
